module.exports = __webpack_public_path__ + "img/54_12.56f20190.png";